import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from './Modal';

interface ConfirmDialogProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  title?: string;
  message: string | React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  confirmDanger?: boolean;
  loading?: boolean;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  onCancel,
  onConfirm,
  title: titleProp,
  message,
  confirmText: confirmTextProp,
  cancelText: cancelTextProp,
  confirmDanger = false,
  loading = false,
}) => {
  const { t } = useTranslation('common');
  const title = titleProp ?? t('confirm');
  const confirmText = confirmTextProp ?? t('confirm');
  const cancelText = cancelTextProp ?? t('cancel');
  return (
    <Modal
      open={open}
      onClose={onCancel}
      title={title}
      width="400px"
      footer={
        <>
          <button className="btn btn-secondary" onClick={onCancel} disabled={loading}>
            {cancelText}
          </button>
          <button
            className={`btn ${confirmDanger ? 'btn-danger' : 'btn-primary'}`}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading && <span className="loading-spinner" />}
            {confirmText}
          </button>
        </>
      }
    >
      <div style={{ fontSize: '0.9rem', color: 'var(--text-2)', lineHeight: 1.6 }}>
        {message}
      </div>
    </Modal>
  );
};

export default ConfirmDialog;
